
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import State from '../../../../docs/State';
import Card from '@devsisters/ui-admin/lib/Card';
import CardHeader from '@devsisters/ui-admin/lib/CardHeader';
import CardContent from '@devsisters/ui-admin/lib/CardContent';
import CardActions from '@devsisters/ui-admin/lib/CardActions';
import Typography from '@devsisters/ui-admin/lib/Typography';
import Button from '@devsisters/ui-admin/lib/Button';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"card"}}>{`Card`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import Card from '@devsisters/ui-admin/lib/Card';
`}</MDXTag></MDXTag>
<Playground __position={0} __code={'<Card>\n  <CardHeader\n    title=\"수 튼튼하며, 풀이 운다. 투명하되 아니더면, 우리의 피다. 대중을 용기가 우리 사막이다.\"\n    description=\"뜨거운지라, 현저하게 속잎나고, 그들에게 것이다. 가치를 많이 능히 귀는 찾아다녀도, 이상 넣는 찬미를 아니다. 위하여, 구할 작고 아니더면, 있음으로써 많이 부패를 사막이다.\"\n  />\n  <CardContent>\n    <Typography component=\"body\">\n      옷을 따뜻한 무엇이 모래뿐일 이상 이것이다. 구하지 하는 이것을 예가\n      봄바람이다. 이상이 그것은 때까지 꽃이 목숨이 못하다 얼마나 있는가? 하는\n      낙원을 이상, 이것이다. 같이, 이상 내는 열매를 영원히 아름답고 많이 싸인\n      심장은 말이다. 전인 남는 부패를 열매를 우리의 공자는 커다란 사랑의\n      군영과 그리하였는가? 보는 동산에는 청춘 것이 얼음이 칼이다. 우리 같이\n      튼튼하며, 보라. 청춘에서만 그들은 없으면, 이상의 못할 현저하게 것은\n      이것이다. 소금이라 동력은 평화스러운 더운지라 것이다.보라, 봄바람이다.\n      할지니, 품으며, 열락의 그리하였는가?\n    </Typography>\n  </CardContent>\n  <CardActions>\n    <Button color=\"primary\">공유하기</Button>\n    <Button color=\"primary\">더보기</Button>\n  </CardActions>\n</Card>'} __scope={{props: this ? this.props : props,State,Card,CardHeader,CardContent,CardActions,Typography,Button}}>
  <Card>
    <CardHeader title="수 튼튼하며, 풀이 운다. 투명하되 아니더면, 우리의 피다. 대중을 용기가 우리 사막이다." description="뜨거운지라, 현저하게 속잎나고, 그들에게 것이다. 가치를 많이 능히 귀는 찾아다녀도, 이상 넣는 찬미를 아니다. 위하여, 구할 작고 아니더면, 있음으로써 많이 부패를 사막이다." />
    <CardContent>
      <Typography component="body">
        옷을 따뜻한 무엇이 모래뿐일 이상 이것이다. 구하지 하는 이것을 예가 봄바람이다. 이상이 그것은 때까지 꽃이 목숨이 못하다 얼마나 있는가? 하는 낙원을 이상, 이것이다. 같이, 이상 내는 열매를 영원히 아름답고 많이 싸인 심장은 말이다. 전인 남는 부패를 열매를 우리의 공자는 커다란 사랑의 군영과 그리하였는가? 보는 동산에는 청춘 것이 얼음이 칼이다. 우리 같이 튼튼하며, 보라. 청춘에서만 그들은 없으면, 이상의 못할 현저하게 것은 이것이다. 소금이라 동력은 평화스러운 더운지라 것이다.보라, 봄바람이다. 할지니, 품으며, 열락의 그리하였는가?
      </Typography>
    </CardContent>
    <CardActions>
      <Button color="primary">공유하기</Button>
      <Button color="primary">더보기</Button>
    </CardActions>
  </Card>
</Playground>
           </MDXTag>
  }
}
  